import { useEffect, useState } from "react";
import { server } from "../../server";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QRCode from "qrcode";
import { capitalizeWords, formatDate } from "../../functions";
import FeeLedger from "../fee/feeLedger";

function ViewStudent() {
  const [error, setError] = useState(null);
  const { state } = useLocation();
  const admissionNo = state?.admissionNo;
  const [image, setImage] = useState(null);
  const [studentData, setStudentData] = useState(null);
  const [qrDataURL, setQrDataURL] = useState("");

  useEffect(() => {
    const generateQR = async () => {
      try {
        const url = await QRCode.toDataURL(admissionNo);
        setQrDataURL(url);
      } catch (err) {
        console.error("QR Code generation failed:", err);
      }
    };

    if (admissionNo) {
      generateQR();
    }
  }, [admissionNo]);

  const [formData, setFormData] = useState({
    currentClass: "",
    session: "2025-26",
    studentDetails: {
      studentId: "",
      admission_no: "",
      admissionDate: "",
      name: "",
      admissionInClass: "",
      admissionInSection: "",
      currentSection: "",
      rollNo: "",
      gender: "",
      dateOfBirth: "",
      category: "",
      house: "",
      aadhar_no: "",
      religion: "",
      bloodGroup: "",
      handicap: "",
      previousSchoolName: "",
      previousSchoolAddress: "",
      underMidSection: "",
      applicableMonth: "",
      phoneNo: "",
      studentImage: "",
    },
    parentDetails: [
      {
        name: "",
        qualification: "",
        occupation: "",
        phone: "",
        email: "",
        Income: "",
        relation: "Father",
      },
      {
        name: "",
        qualification: "",
        occupation: "",
        phone: "",
        email: "",
        Income: "",
        relation: "Mother",
      },
      {
        name: "",
        phone: "",
        aadhaarNo: "",
        relation: "Guardian",
      },
      {
        name: "",
        phone: "",
        aadhaarNo: "",
        relation: "Emergency Guardian",
      },
    ],
    presentAddress: {
      address: "",
      city: "",
      pincode: "",
      state: "",
    },
    permanentAddress: {
      address: "",
      city: "",
      pincode: "",
      state: "",
    },
    certificate: [],
  });

  useEffect(() => {
    const fetchStudent = async () => {
      if (!admissionNo) {
        setError("Please enter Admission No");
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(
          `${server}/getParticularStudentMongodb`,
          { admission_no: admissionNo },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        const studentData = response.data?.["body-json"]?.body?.student;
        if (studentData) {
          setStudentData(studentData);
        } else {
          setError("No Student Data Found");
          setStudentData(null);
        }
      } catch (err) {
        setError("Student not found or API error.");
        setStudentData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [admissionNo]);

  useEffect(() => {
    if (studentData || image) {
      setFormData((prev) => ({
        ...prev,
        currentClass: studentData.currentClass,
        studentDetails: {
          ...prev.studentDetails,
          ...studentData.studentDetails,
          studentImage: image || studentData?.studentDetails?.studentImage,
        },
        parentDetails: studentData.parentDetails || prev.parentDetails,
        presentAddress: studentData.presentAddress || prev.presentAddress,
        permanentAddress: studentData.permanentAddress || prev.permanentAddress,
        certificate: studentData.certificate,
      }));
    }
  }, [studentData, image]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div>
            <div class="container-fluid mb-4">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="m-3 mt-2 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">View Student</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Student Information</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Student Details</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            View Student
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>

                  <div className="profile-head-bg rounded-top-5 p-5 d-flex justify-content-between align-items-start">
                    <div>
                      <img
                        src={
                          studentData?.studentDetails?.studentImage ||
                          `/assets/images/profile.png`
                        }
                        alt="Image"
                        width="120"
                        height="120"
                        className="object-fit-cover rounded-5 mt-3 border border-3 border-white"
                      />
                      <div class="icon-shape icon-xxl bg-white border rounded-circle position-absolute ms-n4 mt-n1">
                        <img
                          src={qrDataURL}
                          className="rounded-circle"
                          alt="QR"
                          width="50"
                        />
                      </div>
                    </div>

                    <div>
                      <img
                        src={
                          studentData?.parentDetails[0]?.image ||
                          `/assets/images/profile.png`
                        }
                        alt="Father Image"
                        width="120"
                        height="120"
                        className="object-fit-cover rounded-5 mt-3 border border-3 border-white"
                      />
                      <img
                        src={
                          studentData?.parentDetails[1]?.image ||
                          `/assets/images/profile.png`
                        }
                        alt="Mother Image"
                        width="120"
                        height="120"
                        className="object-fit-cover rounded-5 mt-3 border border-3 border-white"
                      />
                    </div>
                  </div>

                  <div className="p-5 rounded-bottom-5 bg-white pt-8 d-flex justify-content-between">
                    <div>
                      <h3 class="m-0 fs-4 lh-1">
                        {studentData?.studentDetails?.name
                          .toLowerCase()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                        <i class="bi bi-check-circle fs-5 text-primary ms-2"></i>
                        <span className="badge bg-success-soft ms-5">
                          {studentData?.currentClass},{" "}
                          {studentData?.studentDetails?.currentSection}
                        </span>
                      </h3>
                      <p className="m-0 fs-5">
                        {studentData?.studentDetails?.admission_no},{" "}
                        {new Date(
                          studentData?.studentDetails?.admissionDate,
                        ).toLocaleDateString("en-GB")}{" "}
                        &mdash; {studentData?.studentDetails?.studentId}
                      </p>
                      <p className="mt-3 mb-0 text-danger lh-sm">
                        (+91) {studentData?.parentDetails[0]?.phone}
                        <br />
                        <span className="text-lowercase">
                          {studentData?.parentDetails[0]?.email}
                        </span>
                      </p>
                      <p className="m-0 lh-sm mt-1 text-capitalize">
                        {studentData?.presentAddress?.address
                          .toLowerCase()
                          .replace(/\b\w/g, (char) => char.toUpperCase())}
                      </p>
                    </div>
                  </div>

                  <div className="p-5 pb-3 rounded-5 mt-1 bg-white">
                    <div className="row g-2">
                      <div className="col-lg-6 col-12">
                        <span class="badge bg-danger-soft">
                          1. Student Details
                        </span>
                        <div className="mt-3">
                          <ol>
                            <li className="lh-sm">
                              Student Id &mdash;{" "}
                              <span className="text-dark">
                                {formData.studentDetails?.studentId}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Admission No &mdash;{" "}
                              <span className="text-dark">
                                {formData.studentDetails?.admission_no}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Admission Date &mdash;{" "}
                              <span className="text-dark">
                                {formatDate(
                                  formData.studentDetails?.admissionDate,
                                )}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Full Name &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.name}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Admission in Class &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.admissionInClass}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Section &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.admissionInSection}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Current Class &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.currentClass}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Section &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.currentSection}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Roll No. &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.rollNo}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Gender &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.gender}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Date Of Birth &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.dateOfBirth}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Category &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.category}
                              </span>
                            </li>
                            <li className="lh-sm">
                              House &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.house}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Blood Group &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.bloodGroup}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Aadhaar No &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.aadhar_no}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Religion &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.religion}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Handicap &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.handicap}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Previous School Name &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.previousSchoolName}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Previous School Address &mdash;{" "}
                              <span className="text-dark">
                                {
                                  formData?.studentDetails
                                    ?.previousSchoolAddress
                                }
                              </span>
                            </li>
                            <li className="lh-sm">
                              Under Mid Session &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.underMidSection}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Applicable Month &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.applicableMonth}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Primary Phone No. &mdash;{" "}
                              <span className="text-dark">
                                {formData?.studentDetails?.phoneNo}
                              </span>
                            </li>
                          </ol>
                        </div>
                      </div>

                      <div className="col-lg-6 col-12">
                        <span class="badge bg-danger-soft">
                          2. Parent Details
                        </span>
                        <div className="mt-3">
                          <ol>
                            <li className="lh-sm">
                              {formData?.parentDetails[0]?.relation}'s Name
                              &mdash;{" "}
                              <span className="text-dark">
                                {capitalizeWords(
                                  formData?.parentDetails[0]?.name,
                                )}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Qualification &mdash;{" "}
                              <span className="text-dark">
                                {formData?.parentDetails[0]?.qualification}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Occupation &mdash;{" "}
                              <span className="text-dark">
                                {formData?.parentDetails[0]?.occupation}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Phone No. &mdash;{" "}
                              <span className="text-dark">
                                {formData?.parentDetails[0]?.phone}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Email Address &mdash;{" "}
                              <span className="text-dark text-lowercase">
                                {formData?.parentDetails[0]?.email}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Annual Income &mdash;{" "}
                              <span className="text-dark">
                                {formData?.parentDetails[0]?.Income || "NA"}
                              </span>
                            </li>
                          </ol>
                          <hr className="w-25 ms-3" />
                          <ol>
                            <li className="lh-sm">
                              {formData?.parentDetails[1]?.relation}'s Name
                              &mdash;{" "}
                              <span className="text-dark">
                                {capitalizeWords(
                                  formData?.parentDetails[1]?.name,
                                )}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Qualification &mdash;{" "}
                              <span className="text-dark">
                                {formData?.parentDetails[1]?.qualification}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Occupation &mdash;{" "}
                              <span className="text-dark">
                                {formData?.parentDetails[1]?.occupation}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Phone No. &mdash;{" "}
                              <span className="text-dark">
                                {formData?.parentDetails[1]?.phone}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Email Address &mdash;{" "}
                              <span className="text-dark text-lowercase">
                                {formData?.parentDetails[1]?.email}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Annual Income &mdash;{" "}
                              <span className="text-dark">
                                {formData?.parentDetails[1]?.Income || "NA"}
                              </span>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="row g-2">
                      <div className="col-lg-6 col-12">
                        <span class="badge bg-danger-soft mt-2">
                          3. Address
                        </span>
                        <div className="mt-3">
                          <ol>
                            <li className="lh-sm mb-2">
                              Present Address &mdash;{" "}
                              <span className="text-dark">
                                {capitalizeWords(
                                  formData?.presentAddress?.address,
                                )}
                              </span>
                            </li>
                            <li className="lh-sm">
                              State &mdash;{" "}
                              <span className="text-dark">
                                {formData?.presentAddress?.state}
                              </span>
                            </li>
                            <li className="lh-sm">
                              City &mdash;{" "}
                              <span className="text-dark">
                                {formData?.presentAddress?.city}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Pincode &mdash;{" "}
                              <span className="text-dark">
                                {formData?.presentAddress?.pincode}
                              </span>
                            </li>
                          </ol>
                          <hr className="w-25 ms-3" />
                          <ol>
                            <li className="lh-sm mb-2">
                              Permanent Address &mdash;{" "}
                              <span className="text-dark">
                                {capitalizeWords(
                                  formData?.permanentAddress?.address,
                                )}
                              </span>
                            </li>
                            <li className="lh-sm">
                              State &mdash;{" "}
                              <span className="text-dark">
                                {formData?.permanentAddress?.state}
                              </span>
                            </li>
                            <li className="lh-sm">
                              City &mdash;{" "}
                              <span className="text-dark">
                                {formData?.permanentAddress?.city}
                              </span>
                            </li>
                            <li className="lh-sm">
                              Pincode &mdash;{" "}
                              <span className="text-dark">
                                {formData?.permanentAddress?.pincode}
                              </span>
                            </li>
                          </ol>
                        </div>
                      </div>

                      <div className="col-lg-6 col-12">
                        <span class="badge bg-success-soft mt-2">
                          4. Certificate
                        </span>
                        <div className="mt-3">
                          <ol>
                            {formData?.certificate.map((item, index) => (
                              <li key={index} className="lh-sm text-danger">
                                {item}
                              </li>
                            ))}
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="sticky-top top-10 z-1">
                    <div className="bg-white rounded-5">
                      <div className="bg-dark px-5 py-4 rounded-top-5">
                        <div className="mb-2 mt-2">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h5 className="text-white fw-medium lh-1 m-0">
                                Track fee transactions at a glance.
                              </h5>
                              <h5 className="text-white fs-5 fw-light mb-0">
                                Fee Ledger
                              </h5>
                            </div>
                            <Link
                              to="/collect-fees"
                              state={{
                                admissionNo: studentData?.admission_no,
                              }}
                              class="badge bg-light-soft mb-n8"
                            >
                              Collect Fee
                            </Link>
                          </div>
                          <p className="mb-0 mt-2 text-light fw-medium">
                            Amount paid to date
                          </p>
                        </div>
                      </div>

                      <div className="px-5">
                        {studentData?.feeDetails && (
                          <FeeLedger feeDetails={studentData?.feeDetails} />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default ViewStudent;
